import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Candidato } from '../models/candidato.model';
import { catchError } from 'rxjs/operators';
import { CandidatosCsvDTO } from '../models/candidatosCsvDTO.model';

@Injectable({
  providedIn: 'root'
})
export class CanditadosService {
  configHeader: { headers: { Authorization: any; }; };

  candidatos: Candidato[] = [];
  total: number;

  constructor(
    private http: HttpClient
  ) { }

  // public getById(id: number): Observable<Candidato> {
  //   return this.http.get<Candidato>(`${environment.url_api}/candidatos/${id}`)
  // }

  public getAll(): Observable<Candidato[]> {
    return this.http.get<Candidato[]>(`${environment.url_api}/candidatos`)
  }

  public getCandidatosPorIdLoginParticipante(): Observable<Candidato[]> {
    return this.http.get<Candidato[]>(`${environment.url_api}/candidatos/cargos`)
  }

  public getCandidatoPorIdCargo(id: number): Observable<Candidato[]> {
    return this.http.get<Candidato[]>(`${environment.url_api}/candidatos/byCargo?idCargo=${id}`)

  }

  insercaoEmMassaCandidatos(candidato: CandidatosCsvDTO[], token: any){
    console.log(candidato, "candidato ")
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.post(`${environment.url_api}/candidatos/bulk`, candidato, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }  
      )
    })
  }

  excluirCandidatoEleicao(idCandidato: Number, token){
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.delete(`${environment.url_api}/candidatos/${idCandidato}`, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }
  getCandidadosById(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/candidatos/${id}`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error);
            }
        )
    })
  }
  getCandidadosByIdEleicao(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/eleicoes/${id}/cargos/candidatos`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error.message);
            }
        )
    })
  }

  getCandidatosByIdEleicaoLite(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/eleicoes/${id}/cargos/candidatos/lite`, this.configHeader).subscribe(
          payload => {
            resolve(payload);
            }, err => {
              reject(err.error.message);
            }
        )
    })
  }

  public cadastrarCandidatoEleicao(candidato: Candidato, token) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.post(`${environment.url_api}/candidatos`, candidato, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }
      )
    })
  }

  public editarCandidatoEleicao(candidato: Candidato, token, idCandidato: Number) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.put(`${environment.url_api}/candidatos/${idCandidato}`, candidato, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }  
      )
    })
  }

  public emailExclusaoCandidatura(id: number, justificativaExclusao: string, token: any){
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.post(`${environment.url_api}/candidatos/${id}/emailExclusaoCandidatura/`, justificativaExclusao, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }  
      )
    })
  }

}
